import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";

//   const { pathname, search, hash } = props.location;
//   const from = pathname + search + hash;
//   return <Navigate to="/page-not-found" state={{ from }} />;

const generateRoutes = routes => {
  const routeElements = routes.reduce((acc, curr) => {
    if (curr.children) {
      const list = curr.children.map(child => {
        const fullPath = curr.path + child.path;
        return <Route key={fullPath} path={fullPath} element={child.element} />;
      });

      return acc.concat(list);
    } else {
      const fullPath = curr.path;
      return acc.concat(
        <Route key={fullPath} path={fullPath} element={curr.element} />
      );
    }
  }, []);
  routeElements.push(
    <Route
      path="/*"
      key="page-not-found"
      element={<Navigate to="/page-not-found" />}
    />
  );
  return routeElements;
};

export const AppRoutes = ({ routes }) => (
  <Routes>{generateRoutes(routes)}</Routes>
);
